'use client';
import { usePathname } from 'next/navigation';
import Footer from '~/components/footer';
import { NavigationProgress } from '~/components/NavigationProgress';
import Header from '~/components/header';

/**
 * The marketing chrome (header, footer, header-height padding) wraps every page except /owner-portal,
 * which owns its whole viewport with its own shell, nav and theming.
 */
export function SiteChrome({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();
  if (pathname?.startsWith('/owner-portal')) {
    return <>{children}</>;
  }

  return (
    <>
      <Header />
      <NavigationProgress />
      <main className="pt-16">{children}</main>
      <Footer />
    </>
  );
}
